import React from 'react';
import moment from 'moment';

import PlayerRecords from '~/components/PlayerRecords/PlayerRecords';
import StyledComponent from '~/components/Styled/Styled';

import getOr from '~/util/getOr';

import css from './ResultsEventCard.scss';

type Props = {
  event: any;
};

class ResultsEventCard extends React.Component<Props> {
  static displayName = 'ResultsEventCard';

  getEventStatusText() {
    const {
      event_status: eventStatus,
      event_details: eventDetails,
      game_date: gameDate,
      start_date: startDate,
      start_datetime: startDatetime,
    } = this.props.event;
    const date = gameDate || startDate || startDatetime;

    switch (eventStatus) {
      // eslint-disable-next-line no-case-declarations
      case 'pre_game':
        const gameTime = moment(date);
        return (
          <div className={css.statusTitle}>
            {gameTime.format('MMM DD')} &middot; {gameTime.format('h:mm a')}
          </div>
        );

      // eslint-disable-next-line no-case-declarations
      case 'in_progress':
        const tvStation = getOr(eventDetails, 'tv_listings_by_country_code.us[0].short_name', '');
        return (
          <div className={`${css.statusTitle} ${css.statusLive}`}>
            Live
            {!!tvStation.content && (
              <div className={`${css.statusTitle} ${css.statusLive}`}>&nbsp;&middot;&nbsp;</div>
            )}
            {tvStation.content}
          </div>
        );

      case 'final':
        return <div className={css.statusTitle}>Final</div>;
      default:
        return null;
    }
  }

  leagueSlug = getOr(this.props, 'event.league.slug', '');

  renderPlayerRecords() {
    switch (this.leagueSlug) {
      case 'nascar':
      case 'formula1':
        return <PlayerRecords event={this.props.event} />;
      default:
        return null;
    }
  }

  render() {
    const name = getOr(this.props, 'event.name', '');

    return (
      <div className={css.resultEventCardContainer}>
        {this.getEventStatusText()}
        <div className={css.eventName}>{name}</div>
        {this.renderPlayerRecords()}
      </div>
    );
  }
}

export default StyledComponent(ResultsEventCard, [css]);
